import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { UrlModal } from 'src/app/shared/url.model';

@Injectable({
  providedIn: 'root',
})
export class DoctypeService {
  //  URL = "http://206.189.132.38:3005";
  //URL = "http://localhost:3005";

  constructor(private httpClient: HttpClient) {}

  saveDocType(name, token: string, doctorCategory, slug, symptoms) {
    console.log(token);
    return this.httpClient.post(
      UrlModal._URL + '/doc/savedoctortype',
      {
        name: name,
        doctorCategory: doctorCategory,
        slug: slug,
        symptoms: symptoms,
      },
      {
        headers: new HttpHeaders({
          authorization: 'Bearer ' + token,
        }),
      }
    );
  }
  getDocType(token) {
    return this.httpClient
      .get<DocType>(UrlModal._URL + '/doc/getdoctype', {
        headers: new HttpHeaders({
          authorization: 'Bearer ' + token,
        }),
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  onDelete(id, token) {
    return this.httpClient.get(UrlModal._URL + '/doc/deletedoctortype/' + id, {
      headers: new HttpHeaders({
        authorization: 'Bearer ' + token,
      }),
    });
  }

  getAllServices(token) {
    return this.httpClient.get<saveDoctorService>(
      UrlModal._URL + '/sev/getdocservices',
      {
        headers: new HttpHeaders({
          authorization: 'Bearer ' + token,
        }),
      }
    );
  }
}

export interface saveDoctorService {
  status: number;
  message: string;
  doctorService: [
    {
      isDeleted: boolean;
      _id: string;
      serviceName: string;
      createdAt: string;
      updatedAt: string;
      __v: number;
    }
  ];
}

export interface DocType {
  status: string;
  message: string;
  data: [
    {
      _id: string;
      isDeleted: boolean;
      name: string;
      slug: string;
      doctorCategory: string;
      createdAt: string;
      updatedAt: string;
      __v: number;
    }
  ];
}
